// src/components/AdminUsers.jsx

import * as React from "react";
import PropTypes from "prop-types";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import { Button, Box, Typography } from "@mui/material";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import CloseIcon from "@mui/icons-material/Close";

import "./AdminUsers.css";

export default function AdminUsers({
  adminUsers,
  onClose,
  projectName,
  projectToken,
  customTheme,

  onRemoveAdmin, // NEW (placeholder hook)
  onAddAdmin, // NEW (placeholder hook)
}) {
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  const columns = [
    { field: "id", headerName: "ID", flex: 1, minWidth: 260 },
    { field: "givenName", headerName: "First Name", flex: 1, minWidth: 160 },
    { field: "familyName", headerName: "Last Name", flex: 1, minWidth: 160 },
    { field: "email", headerName: "Email", flex: 2, minWidth: 340 },
  ];

  const subtitle = [projectName, projectToken].filter(Boolean).join(" · ");
  const hasSelection = Array.isArray(rowSelectionModel) && rowSelectionModel.length > 0;

  const panelHeaderBg = customTheme.headerWidgetColour;
  const panelHeaderText = customTheme.headerTextColour;

  const gridHeaderBg = customTheme.columnHeaderBackgroundColour;
  const gridHeaderText = customTheme.columnHeaderTextColour;

  const gridFontFamily = customTheme.fontFamily;

  const gridFontSize = customTheme.fontSize;

  const handleAddAdmin = () => {
    if (typeof onAddAdmin === "function") return onAddAdmin();
    console.log("[AdminUsers] onAddAdmin not provided yet");
  };

  const handleRemoveSelected = () => {
    const selectedIds = Array.isArray(rowSelectionModel) ? rowSelectionModel : [];
    if (!selectedIds.length) return;

    if (typeof onRemoveAdmin === "function") return onRemoveAdmin(selectedIds);
    console.log("[AdminUsers] onRemoveAdmin not provided yet. Selected:", selectedIds);
  };

  return (
    <Box
      className="adminUsersRoot"
      style={{
        ["--au-panelHeaderBg"]: panelHeaderBg,
        ["--au-panelHeaderText"]: panelHeaderText,
        ["--au-gridHeaderBg"]: gridHeaderBg,
        ["--au-gridHeaderText"]: gridHeaderText,
        ["--au-fontFamily"]: gridFontFamily,
        ["--au-fontSize"]: gridFontSize,
      }}
    >
      <div className="adminUsersHeader">
        <div className="adminUsersHeaderText">
          <Typography className="adminUsersTitle">Admin Users</Typography>
          {subtitle ? (
            <Typography className="adminUsersSubtitle" title={subtitle}>
              {subtitle}
            </Typography>
          ) : null}
        </div>

        <div className="adminUsersHeaderActions">
          <Button
            className="adminUsersActionBtn adminUsersAddBtn"
            variant="text"
            onClick={handleAddAdmin}
            startIcon={<PersonAddAlt1Icon />}
            title="Add admin"
          >
            Add
          </Button>

          {hasSelection ? (
            <Button
              className="adminUsersActionBtn adminUsersDeleteBtn"
              variant="text"
              onClick={handleRemoveSelected}
              startIcon={<DeleteOutlineIcon />}
              title="Remove selected admin(s)"
            >
              Remove
            </Button>
          ) : null}

          <Button
            className="adminUsersActionBtn adminUsersCloseBtn"
            variant="text"
            onClick={onClose}
            startIcon={<CloseIcon />}
            title="Close"
          >
            Close
          </Button>
        </div>
      </div>

      <div className="adminUsersGridWrap">
        <DataGridPremium
          className="adminUsersGrid"
          rows={Array.isArray(adminUsers) ? adminUsers : []}
          columns={columns}
          getRowId={(row) => row.id}
          checkboxSelection
          disableSelectionOnClick
          pageSize={10}
          rowsPerPageOptions={[5, 10, 25]}
          autoHeight={false}
          style={{ height: 360 }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "auRowEven" : "auRowOdd"
          }
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={(newSelection) => {
            setRowSelectionModel(Array.isArray(newSelection) ? newSelection : []);
          }}
        />
      </div>
    </Box>
  );
}

AdminUsers.propTypes = {
  adminUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      givenName: PropTypes.string,
      familyName: PropTypes.string,
      email: PropTypes.string,
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,

  projectName: PropTypes.string,
  projectToken: PropTypes.string,
  customTheme: PropTypes.object,

  onRemoveAdmin: PropTypes.func, // (selectedIds) => void
  onAddAdmin: PropTypes.func, // () => void
};
